/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-const */
/* eslint-disable consistent-return  */
/* eslint-disable no-prototype-builtins  */

export default {
  _init() {
    if (!this.options.Vue.router) {
      return 'vue-router.2.x.js : Vue.router must be set.';
    }
  },
  _bindData(data, ctx) {
    let error;
    let success;

    data = data || {};

    error = data.error;
    success = data.success;

    data.query = ctx.$route.query || {};

    if (data.success) { data.success = (res) => { success.call(ctx, res); }; }
    if (data.error) { data.error = (res) => { error.call(ctx, res); }; }

    return data;
  },
  _beforeEach(routerBeforeEach, transitionEach) {
    let _this = this;
    this.options.Vue.router.beforeEach((transition, location, next) => {
      routerBeforeEach.call(_this, () => {
        let auth;

        if (transition.to) {
          auth = transition.to.auth;
        } else {
          const authRoutes = transition.matched.filter(route => route.meta.hasOwnProperty('auth'));

          // matches the nested route, the last one in the list
          if (authRoutes.length) {
            auth = authRoutes[authRoutes.length - 1].meta.auth;
          }
        }

        transitionEach.call(_this, transition, auth, (redirect) => {
          // console.log('beforeEach', transition, auth, redirect);
          if (!redirect) {
            (next || transition.next)();
            return;
          }

          // router v2.x
          if (next) {
            next(redirect);
          } else {
            this.options.router._routerReplace.call(this, redirect);
          }
        });
      });
    });
  },
  _routerReplace(data) {
    const router = this.options.Vue.router;
    router.replace.call(router, data);
  },
  _routerGo(data) {
    const router = this.options.Vue.router;
    (router.push || router.go).call(router, data);
  },
};



// WEBPACK FOOTER //
// ./src/middleware/router/vue-router.2.x.js